(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('[data-section-id="{{ section.id }}"] button[type="submit"]');
    if (btn) btn.textContent = 'Join Mamey';
  });

  } catch(e) { console.error(e); }
})();
})();
